import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services';
import { DeleteTriggerParams, DeleteTriggerResponse, ListTriggersParams, ListTriggersResponse, UpsertNotificationTriggerParams, UpsertNotificationTriggerResponse } from 'src/app/core/proto/luckyluke/triggers/dtos';

@Injectable({
  providedIn: 'root'
})
export class TriggersService {

  constructor(
    private _apiService: ApiService,
  ) { }

  /**
   * permissions: {mode: "+c", res: "triggers.*", dom: "[brandId]", tokenDom: "[brandUuid]"}
   * @param upsertNotificationTriggerParams
   * @returns
   */
  upsertNotificationTrigger(
    upsertNotificationTriggerParams: UpsertNotificationTriggerParams,
  ): Observable<UpsertNotificationTriggerResponse> {
    return this._apiService.post(
      '/v2/notification-triggers',
      upsertNotificationTriggerParams,
    )
  }

  /**
   * permissions: {mode: "+r", res: "triggers.*", dom: "[brandId]", tokenDom: "[brandUuid]"}
   * @param listTriggerParams
   * @returns
   */
  listTriggers(
    listTriggersParams: ListTriggersParams,
  ): Observable<ListTriggersResponse> {
    let params = this._apiService.queryParams(listTriggersParams);

    return this._apiService.get(
      '/v2/triggers',
      params,
    )
  }

  /**
   * permissions: {mode: "+r", res: "triggers.*", dom: "[brandId]", tokenDom: "[brandUuid]"}
   * @param listTriggerParams
   * @returns
   */
  deleteTrigger(
    deleteTriggerParams: DeleteTriggerParams,
  ): Observable<DeleteTriggerResponse> {
    return this._apiService.delete(
      `/v2/trigger/${deleteTriggerParams.triggerId}`,
    )
  }
}
